import { useCallback, useEffect, useState } from 'react';
import { useToast } from '@/shared/providers';
import { feriadosService } from '../services/feriadosService';
import { type CalendarioResumo } from '../types/feriadosTypes';
type CarregamentoStatus = 'loading' | 'succeeded' | 'failed';
export function useCalendariosFeriados() {
  const toast = useToast();
  const [calendarios, setCalendarios] = useState<CalendarioResumo[]>([]);
  const [status, setStatus] = useState<CarregamentoStatus>('loading');
  const [salvando, setSalvando] = useState(false);
  const recarregar = useCallback(() => {
    setStatus('loading');
    feriadosService.listarCalendarios().then(lista => {
      setCalendarios(lista);
      setStatus('succeeded');
    }).catch(() => setStatus('failed'));
  }, []);
  useEffect(() => {
    recarregar();
  }, [recarregar]);
  const criarCalendario = async (ano: number, importarNacionais: boolean): Promise<boolean> => {
    setSalvando(true);
    try {
      await feriadosService.criarCalendario(ano, importarNacionais);
      toast.showSuccess('Calendário criado', `Calendário de ${ano} criado.`);
      recarregar();
      return true;
    } catch (error) {
      toast.showError('Não foi possível criar', error instanceof Error ? error.message : undefined);
      return false;
    } finally {
      setSalvando(false);
    }
  };
  const anoAtual = new Date().getFullYear();
  const anosRelevantes = [anoAtual, anoAtual + 1];
  const anosFaltando = anosRelevantes.filter(ano_0 => !calendarios.some(calendario => calendario.ano === ano_0));
  return {
    calendarios,
    status,
    salvando,
    criarCalendario,
    recarregar,
    anosFaltando
  };
}